import React, { FunctionComponent } from 'react';

type Props = {
  section: 'company' | 'userAuth' | 'planPurchase';
  name: string;
  divClassName: string;
  labelName: string;
  labelHtmlFor: string;
  required: boolean;
  inputId: string;
  inputClassName: string;
  placeholder?: string;
  value: string;
  onChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean | number) => void;
  hintMessage?: string;
  hintId?: string;
  type?: string;
};

export const Presentation: FunctionComponent<Props> = ({
  section,
  name,
  divClassName,
  labelName,
  labelHtmlFor,
  required,
  inputId,
  inputClassName,
  placeholder,
  value,
  onChange,
  hintMessage,
  hintId,
  type
}) => {
  return (
    <div className={divClassName}>
      <div className="form-group__title">
        <label htmlFor={labelHtmlFor} className="col-xs-3 col-form-label">{labelName}</label>
        {required &&
          <span className="col-xs-2 high">&nbsp;必須</span>
        }
      </div>
      <div className="col-xs-7 input hidden-xs">
        <input
          type={type ?? 'text'}
          id={inputId}
          className={inputClassName}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(section, name, e.target.value)}
        />
        {hintMessage &&
          <span id={hintId} className="form-text text-muted">
            {hintMessage}
          </span>
        }
      </div>
    </div>
  );
};
